<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="1020">
    <v-card>
        <v-toolbar dense>
            <v-icon  left color="primary">mdi-account-multiple</v-icon> Customer Details
            <v-spacer/>
              <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
             <v-form
                ref="form"
                class="mt-3"
                v-model="valid"
                lazy-validation
              >
              
                <v-row>
                    <v-col cols="7">
                       <v-row>
                         <v-col cols="6">
                            <!-- <v-img :src="$store.state.gallerylogo" width="70%"/> -->
                            <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                         </v-col>
                         <v-col cols="6">
                             <v-text-field
                          v-model="customer.trade_name"
                          label="Trade Name"
                          :rules="textRules"
                          required
                          dense
                          outlined
                        ></v-text-field>
                                <v-autocomplete
                                v-model="customer.type"
                                label="Trade Type"
                                :items="$store.state.customertypes"
                                item-text="name"
                                item-value="id"
                                :rules="textRules"
                                required
                                dense
                                outlined
                              ></v-autocomplete>
                              <v-autocomplete
                              v-model="customer.area_code"
                              label="Route code"
                              :items="AREACODES"
                              :rules="textRules"
                              required
                              dense
                              outlined
                            ></v-autocomplete>
                          
                         </v-col>
                         
                       </v-row>

                       Contact Details
                        <v-row >
                           <v-col cols="5">
                           <v-text-field
                              v-model="customer.lastname"
                              label="Lastname"
                                hide-details
                              :rules="textRules"
                              required
                              dense
                              outlined
                            ></v-text-field>
                           </v-col>
                            <v-col cols="5">
                             <v-text-field
                              v-model="customer.firstname"
                              label="Firstname"
                              :rules="textRules"
                              required
                                hide-details
                              dense
                              outlined
                            ></v-text-field>
                            </v-col>
                             <v-col cols="2">
                            <span >
                              <v-text-field
                                v-model="customer.middle"
                                  hide-details
                                label="M.I."
                                dense
                                outlined
                              ></v-text-field>
                              </span>
                             </v-col>
                        </v-row>

                        <v-row>
                           <v-col cols="6">
                           <v-text-field
                              v-model="customer.email"
                              label="Email"
                              dense
                              outlined
                            ></v-text-field>
                           </v-col>
                            <v-col cols="6">
                             <v-text-field
                              v-model="customer.contact_number"
                              label="Contact Number"
                              dense
                              outlined
                            ></v-text-field>
                            </v-col>
                        </v-row>
                        

                        <v-row no-gutters>
                              <gmap-autocomplete
                              :value="customer.address"
                              placeholder="Enter Address"
                                style="width: 100%; padding:8px 12px !important; border-bottom: 1px solid #999; margin-bottom: 10px;"
                                  @place_changed="setPlace">
                            </gmap-autocomplete>
                            <Gmap-Map  ref="mapRef" style="width: 100%; height: 250px;" :zoom="8" :center="{lat: 7.448212, lng: 125.809425}">
                            <Gmap-Marker v-for="(marker, index) in markers"
                              :key="index"
                              :position="marker.position"
                              ></Gmap-Marker>
                            <Gmap-Marker
                              v-if="place"
                              :label="entry.trade_name"
                              :position="{
                                lat: this.place.geometry.location.lat(),
                                lng: this.place.geometry.location.lng(),
                              }"
                              ></Gmap-Marker>
            </Gmap-Map>
                        </v-row>   
                    </v-col>
                    <v-col>
                        <v-toolbar dense dark color="primary">
                          DISCOUNTS
                          <v-spacer/>
                          <span style="width: 140px;">
                          <v-text-field
                              v-model="search"
                              label="Search"
                              append-icon="mdi-magnify"
                              hide-details
                              dense
                              outlined
                            ></v-text-field>
                          </span>
                        </v-toolbar>
                        <v-data-table
                                class="va-table mt-1 elevation-1"
                                color="#f1f1f1"
                                dense
                                :search="search"
                                disable-sort
                                :headers="[{text:'ITEM ', value:'product_code'}, {text:'AMOUNT'}]"
                                :items="discounts"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                           <td>{{ item.product_code }}</td>
                                           <td width="90px">
                                               <v-text-field
                                               v-model="item.amount"
                                               @change="SaveDiscount(item)"
                                                hide-details
                                                dense
                                              ></v-text-field>
                                           </td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>

                    </v-col>
                </v-row>
             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="default" small  @click="emitToParent('close')">CLOSE</v-btn>
                <v-btn color="error" v-if="state !='new'" small  @click="confirm_action='deactivate', confirm_text='Would like to deactivate this customer?', confirm=true">Deactivate Customer</v-btn>
                <v-btn color="warning" v-if="state !='new'" small @click="confirm_action='reset', confirm_text='Reset customer discounts?', confirm=true">Reset Discounts</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
      <va-confirm :show="confirm" :text="confirm_text" okbtn="OK" cancelbtn="Cancel" @DialogEvent="cfEvent"/>
  </v-dialog>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    item: {
        type: Object,
        default: ()=>{ return {}}
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      confirm: false,
      confirm_action:'',
      confirm_text:'',
      search:'',
      textRules: [
        v => !!v || 'Field is required'
      ],
      customer:{},
      markers: [],
      cus_Lat:null,
      cus_Lng:null,
      discounts:[],
      place: null,
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      },
      google: gmapApi,
      CUSTOMERSELECTION() {
      var noParent = {id:0,firstname:'No Parent'}
      var selection = this.customerlist
      selection.unshift(noParent)
      return selection
    },
    AREACODES() {
      var codes = this.$store.state.settings.reduce((res,item)=>{
        if(item.alias == 'codes') {
            res = item.value
        }
        return res
      },'')
      return codes.split(',')
    },
  },
  watch: {
    show (v) {
      if(v) {
        this.customer={}
        if(this.state!='new') {
            this.customer=this.item
            this.getDiscounts()
        } else {
          this.discounts = []
           this.LoadMap()
        } 
      }
    }
  },
  methods: {
    cfEvent(res) {
        this.confirm = false
      if(res !=  'cancel'){
          if(this.confirm_action =='deactivate') {
              this.Deactivate()
          } else if(this.confirm_action =='reset') {
              this.ResetDiscounts()
          }
      }
    },
    LoadMap() {
      this.$gmapApiPromiseLazy({}).then(() => {
        var geocoder = new this.google.maps.Geocoder()
        geocoder.geocode({'address': this.customer.address}, (result, status) => {
          if(status == 'OK'){
            this.setPlace(result[0]) // do something with the first result
          }
        })
      })
    },
    validate () {
        if (this.$refs.form.validate()) {
         // this.emitToParent(this.state)
         this.Save()
        }
    },
    emitToParent (action) {
         if(this.customer.status == "delete") {this.customer.status = 'deleted'}
         this.$emit('DialogEvent', {action: action, customer:this.customer})
    },
    setPlace(place) {
       
        this.place = place
        this.customer.address = this.place.formatted_address
          this.usePlace()
    
      },
      usePlace() {
        if (this.place) {
            this.markers=[]
          this.markers.push({
            position: {
              lat: this.place.geometry.location.lat(),
              lng: this.place.geometry.location.lng(),
            }
          })
          this.customer.lat = this.place.geometry.location.lat()
          this.customer.long = this.place.geometry.location.lng()

           this.$refs.mapRef.$mapPromise.then((map) => {
                 map.panTo({lat:this.customer.lat, lng: this.customer.long})
                })
          this.place = null;
        }
      },
    ResetDiscounts() {
         this.$http.post('customer/reset_discount', this.customer).then(response => {
                response.data.status?this.VA_ALERT('success',response.data.message):this.VA_ALERT('error',response.data.message)
                this.getDiscounts()
             }).catch(e => {
                console.log(e.data)
            })
      },
      SaveDiscount(item){
        var param = {}
        param.customer = item.customer
        param.product_code = item.product_code
        param.id = item.id
        param.amount = item.amount.toString()
         this.$http.post('customer/update_discount', param).then((response) => {
              this.GET_RESPONSE(response)
              }).catch(e => {
                console.log(e.data)
            })
      },
      getDiscounts() {
         this.$http.post('customer/get_discounts', {customer:this.customer.id}).then(response => {
                response.data.items !=null?this.discounts=response.data.items:this.discounts=[]
              }).catch(e => {
                console.log(e.data)
            })
      },
      Deactivate(){
        this.$http.post('customer/delete', this.customer).then(response => {
                response.data.status?this.VA_ALERT('success',response.data.message):this.VA_ALERT('error',response.data.message)
                 this.$emit('DialogEvent', {action: "close"})
              }).catch(e => {
                console.log(e.data)
            })
      },
      Save(){
        if( this.customer.lat != undefined) {
        this.customer.lat = this.customer.lat.toString()
        this.customer.long = this.customer.long.toString()
        }
        this.$http.post(this.state=='new'?'customer/add':'customer/update', this.customer).then(response => {
                response.data.status?this.VA_ALERT('success',response.data.message):this.VA_ALERT('error',response.data.message)
                 this.$emit('DialogEvent', {action: "close"})
              }).catch(e => {
                console.log(e.data)
            })
      }
  }
}
</script>
